var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import cls from 'classnames';
import { tools } from 'rcm-mobile';
import './style/index.scss';
const { dom } = tools;
// 当存在遮罩时，限制滚动，记录恢复的状态
const windowOverflow = window.getComputedStyle(document.documentElement).overflow;
/**
 * @author sayll
 * @version 0.0.1
 */
export default class Popup extends React.PureComponent {
    constructor(props) {
        super(props);
        this.refPopupMask = React.createRef();
        this.refPopupModal = React.createRef();
        this.state = {
            visible: props.visible
        };
    }
    componentDidMount() {
        this.handleToggleVisible();
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.visible !== prevState.visible) {
            return { visible: nextProps.visible };
        }
        return null;
    }
    getSnapshotBeforeUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) {
            this.handleToggleVisible();
        }
        return null;
    }
    render() {
        const _a = this.props, { prefixCls, className, children, visible, mask, onClickMask, offset: _offset } = _a, resetProps = __rest(_a, ["prefixCls", "className", "children", "visible", "mask", "onClickMask", "offset"]);
        const offset = _offset || {};
        return (<div className={cls(prefixCls, className, { [`${prefixCls}-visible`]: visible })} {...resetProps}>
        <div ref={this.refPopupModal} className={`${prefixCls}-modal`} style={{
            top: offset.top !== undefined ? offset.top : 'auto',
            left: offset.left !== undefined ? offset.left : 'auto',
            right: offset.right !== undefined ? offset.right : 'auto',
            bottom: offset.bottom !== undefined ? offset.bottom : 'auto'
        }}>{children}</div>
        {mask ? <div ref={this.refPopupMask} onClick={onClickMask} className={`${prefixCls}-mask`}/> : null}
      </div>);
    }
    handleOpen() {
        const { onOpen } = this.props;
        onOpen && onOpen();
    }
    handleClose() {
        const { onClose } = this.props;
        onClose && onClose();
    }
    // 参数形式给销毁时使用，有待优化
    handleToggleVisible(visible = null, callback) {
        return new Promise((resolve) => {
            const { mask } = this.props;
            if (visible === null) {
                visible = this.state.visible;
            }
            dom.toggle(this.refPopupModal.current, visible, this.props.animation, () => {
                resolve(visible ? this.handleOpen() : this.handleClose());
                callback && callback();
            });
            if (mask) {
                dom.toggle(this.refPopupMask.current, visible, 'opacity');
                if (visible) {
                    document.body.style.overflow = document.documentElement.style.overflow = 'hidden';
                }
                else {
                    document.body.style.overflow = document.documentElement.style.overflow = windowOverflow;
                }
            }
        });
    }
    /**
     * 创建一个弹窗
     * @public
     * */
    static create(options, callback) {
        return new Promise(resolve => {
            const { content, rootElement, onBeforeClose } = options, props = __rest(options, ["content", "rootElement", "onBeforeClose"]);
            const div = document.createElement('div');
            rootElement ? rootElement.appendChild(div) : document.body.appendChild(div);
            let loaded = false;
            let destroyed = false;
            ReactDOM.render(<Popup {...props} ref={(ref) => {
                if (loaded)
                    return; // 避免重复初始化
                loaded = true;
                const sender = {
                    ref,
                    destroy() {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (destroyed)
                                return; // 避免重复卸载组件
                            if (onBeforeClose && (yield onBeforeClose()) === false)
                                return; // 满足条件才允许关闭
                            destroyed = true;
                            yield ref.handleToggleVisible(false);
                            ReactDOM.unmountComponentAtNode(div);
                            div.parentNode.removeChild(div);
                        });
                    }
                };
                resolve(sender);
                callback && callback(sender);
            }}>{tools.helper.getReactNode(content)}</Popup>, div);
        });
    }
}
Popup.defaultProps = {
    prefixCls: 'x-popup',
    animation: 'opacity',
    offset: { top: '30%', left: 0, right: 0 },
    visible: true,
    mask: false
};
